var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFiTsGpsNavigation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m24,12.5h-2.025c-.255,5.115-4.36,9.22-9.475,9.475v2.025h-1v-2.025c-5.115-.255-9.22-4.36-9.475-9.475H0v-1h2.019c.194-3.912,2.641-7.24,6.072-8.703l-.934,1.629c-2.363,1.516-3.96,4.105-4.125,7.074h1.967v1h-1.975c.253,4.563,3.912,8.222,8.475,8.475v-1.975h1v1.975c4.563-.253,8.222-3.912,8.475-8.475h-1.975v-1h1.968c-.165-2.957-1.749-5.538-4.096-7.056l-.944-1.638c3.421,1.467,5.859,4.789,6.053,8.694h2.019v1ZM12-.003l4.88,8.469c.13.25.16.515.094.767-.067.257-.227.475-.45.61-.306.188-.68.182-1.019-.017l-3.504-1.292-3.608,1.37c-.094.062-.237.098-.393.098-.096,0-.196-.014-.293-.043-.252-.078-.458-.253-.583-.494-.153-.301-.153-.658,0-.956L12-.003Zm-3.988,8.973c-.004.012-.004.026.002.038l3.983-1.542,4.052,1.514-4.045-6.979-3.992,6.968Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiTsGpsNavigation);
export default __webpack_public_path__ + "static/media/fi-ts-gps-navigation.f3aa5e8b10dad2baac1bbcca9fbc5bfc.svg";
export { ForwardRef as ReactComponent };